import { atom, useAtom } from 'jotai';

const isDrawerOpenAtom = atom<boolean>(true);

export { isDrawerOpenAtom };
